import * as React from 'react';
import { Avatar } from 'components';
require('./style.css');

interface IProps {
	imageUrl: string;
	editFunction: any;
}

const AvatarWithOptionalEdit = (props: IProps) => {
	const { imageUrl, editFunction } = props;
	return (
		<Avatar imageUrl={imageUrl}>
			{editFunction ? (
				<button type="button" className="avatarChangeIcon" onClick={editFunction}>
					<img src={`${require('../../../containers/Html/icons/glossiq/edit.svg')}`} />
					<label>EDIT</label>
				</button>
			) : null}
		</Avatar>
	);
};

export { AvatarWithOptionalEdit };
